import React from "react";
import { Award } from "lucide-react";

const certs = [
  { name: "APEDA", desc: "Agricultural and Processed Food Products Export Development Authority alignment for agricultural exports.", status: "Available" },
  { name: "IEC", desc: "Import Export Code issued by DGFT, Ministry of Commerce.", status: "Available" },
  { name: "GST", desc: "Goods and Services Tax registration under Indian law.", status: "Available" },
  { name: "LLP Registration", desc: "Grewal & Namburu Agro Traders LLP — Ministry of Corporate Affairs.", status: "Available" },
  { name: "FSSAI", desc: "Food Safety and Standards Authority of India compliance framework.", status: "Under Process" },
  { name: "MSME / Udyam", desc: "Udyam registration under Ministry of MSME.", status: "Available" },
];

const statusStyle = (s) => s === "Available" ? "bg-[#004225] text-white" : "bg-[#F7F2E2] text-[#B5942D] border border-[#D4AF37]/40";

const Certifications = () => (
  <div>
    <section className="bg-[#004225] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Certifications & Compliance</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Certifications & Compliance</h1>
        <p className="mt-3 max-w-3xl text-white/80">Certifications relevant to Indian agricultural exports. Third-party pre-shipment inspection can be arranged through SGS, Intertek or Bureau Veritas per buyer requirement.</p>
      </div>
    </section>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {certs.map((c) => (
          <div key={c.name} className="bg-white border border-[#004225]/10 rounded-sm p-6 card-elevate">
            <Award className="h-5 w-5 text-[#D4AF37]" />
            <div className="mt-3 flex items-center justify-between">
              <div className="font-display text-lg text-[#004225]">{c.name}</div>
              <span className={`text-[10px] font-eyebrow px-2 py-1 rounded-full ${statusStyle(c.status)}`}>{c.status}</span>
            </div>
            <p className="mt-2 text-[13px] text-[#171717]/75">{c.desc}</p>
          </div>
        ))}
      </div>
      <p className="mt-6 text-[12px] text-[#171717]/60">Certificate numbers and documentation are shared with verified buyers upon request.</p>
    </section>
  </div>
);

export default Certifications;
